import React, { Component } from 'react'
import VideoCover from 'react-video-cover'
import { Container } from '@material-ui/core'
class Video extends Component {

    componentDidMount() {
        this.videoRef.play();
    }
    render() {
        const videoOptions = {
            src: './bcs.mp4',
            ref: videoRef => {
                this.videoRef = videoRef;
            },
            onBlur: () => {
                this.videoRef.play();
            },
            onClick: () => {
                if (this.videoRef && this.videoRef.paused) {
                    this.videoRef.play();
                } else if (this.videoRef) {
                    this.videoRef.pause();
                }
            },
            title: 'click to play/pause',
        };
        return (
            <div>
                <div style={{
                    width: '100%',
                    height: '100%',
                    overflow: 'hidden',
                    filter: 'drop-shadow(2px 4px 6px black)'
                }}>
                    <VideoCover
                        videoOptions={videoOptions}
                    />
                </div>
            </div>
        );
    }
}
export default Video
